import gql from 'graphql-tag'

export const marcarNotificacoesComoVisualizadasGql = gql`
  mutation MarcarNotificacoesComoVisualizadas {
    marcarNotificacoesComoVisualizadas
  }
`
